import { createContext, useContext } from 'react'

interface QuestionnaireActionsContextValue {
  onSkipToResults: () => void
}

/**
 * Context that surfaces questionnaire-level action callbacks to deeply-nested
 * components (e.g. QuestionnaireHeader) without prop-drilling through Odyssey.
 */
export const QuestionnaireActionsContext = createContext<QuestionnaireActionsContextValue>({
  onSkipToResults: () => {},
})

export const useQuestionnaireActions = () => useContext(QuestionnaireActionsContext)
